<ui-section>
  <ui-block width="fill">
    <ui-button (click)="addAssignmentRec()">Open modal</ui-button>
  </ui-block>
</ui-section>